import { Component, OnInit } from '@angular/core';
import {
  LastVsThisWeekSalesAmountSummaryCardComponent,
  DashboardKpiService,
  Timespan,
  SalesSummaryEntity
} from 'gung-dashboard';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-last-vs-this-week-sales-amount-summary-card',
    templateUrl: './colmec-last-vs-this-week-sales-amount-summary-card.component.html',
    styleUrls: ['./colmec-last-vs-this-week-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class ColmecLastVsThisWeekSalesAmountSummaryCardComponent
  extends LastVsThisWeekSalesAmountSummaryCardComponent
  implements OnInit
{
  constructor(protected dashboardKpiService: DashboardKpiService) {
    super(dashboardKpiService);
  }

  ngOnInit() {
    const thisWeekSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Week);
    const lastWeekSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastWeek);

    forkJoin({
      salesSummaryGroupsThisWeek: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisWeekSpan.fromDate)
        .pipe(first()),
      salesSummaryGroupsLastWeek: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastWeekSpan.fromDate, lastWeekSpan.toDate)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisWeek, salesSummaryGroupsLastWeek }) => {
      this.salesAmountThisWeek = salesSummaryGroupsThisWeek.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.salesAmountLastWeek = salesSummaryGroupsLastWeek.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.loaded = true;
    });
  }
}
